import { FC } from "react";
import { Datagrid, List, TextField, ReferenceField } from "react-admin";

import CustomPagination from "../../components/CustomPagination";
import TimestampField from "../../components/TimestampField";
import useCurrentUser from "../../hooks/useCurrentUser";
import useSharedStyles from "../../hooks/useSharedStyles";
import { AppResource } from "../../types/resource.types";
import CourtsFilters from "./components/CourtsFilter";
import CourtActions from "./components/CourtActions";
import ListMinSlot from "./components/ListMinSlot";
import EmptyDataText from "../../components/EmptyDataText";

const CourtsList: FC<any> = (props) => {
  const { styles } = useSharedStyles();
  const { user } = useCurrentUser();

  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      filters={<CourtsFilters />}
      bulkActionButtons={false}
      exporter={false}
      filter={{ sportClubId: user.id }}
    >
      <Datagrid rowClick="edit" empty={<EmptyDataText message="No courts yet!" />}>
        <TextField source="name.en" label="Name" sortable={false} />
        <ReferenceField
          label="Category"
          source="courtCategoryId"
          reference={AppResource.courtsCategories}
          link={false}
          sortable={false}
        >
          <TextField source="title.en" />
        </ReferenceField>
        <TextField source="description.en" label="Description" sortable={false} cellClassName={styles.truncate2} />
        <ListMinSlot label="Min Slot (Min)" sortable={false} />
        <TextField source="pricePerHour" label="Price per hour" sortable={false} />
        <TextField source="maxPlayers" label="Max Players" sortable={false} />
        <TimestampField source="createdAt" label="Created At" />
        <CourtActions />
      </Datagrid>
    </List>
  );
};

export default CourtsList;
